import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router'
import toast from 'react-hot-toast'
import { getPrivilegeLevel } from 'utils/privilegeLevel'

/**
 * Sends a user below `level` to the start page with a short note, instead of rendering a page whose queries
 * graphql-api would refuse. The sidebar hides these pages, but a bookmark or a link someone was sent still
 * opens them, and before T4.17 the refusal signed the user out within a second of every login (Simplex,
 * 2026-10-23).
 */
const RequirePrivilegeLevel: React.FC<{ level: number; children: React.ReactNode }> = ({ level, children }) => {
  const allowed = getPrivilegeLevel() >= level
  if (!allowed) return <NoAccess />
  return <>{children}</>
}

const NoAccess: React.FC = () => {
  const { t } = useTranslation()
  useEffect(() => {
    // A fixed id, so StrictMode's second effect run doesn't show it twice.
    toast.error(t('RequirePrivilegeLevel.noAccess'), { id: 'require-privilege-level' })
  }, [t])
  return <Navigate to="/" replace />
}

export default RequirePrivilegeLevel
